(() => {
  const form = document.getElementById('LanguageToggle');
  const source = document.getElementById('InterfaceTranslations');
  if (!form || !source) return;
  const pairs = JSON.parse(source.textContent);
  const reverse = Object.fromEntries(Object.entries(pairs).map(([es,en]) => [en,es]));
  let lang = document.documentElement.lang.startsWith('en') ? 'en' : 'es';
  try { const saved = localStorage.getItem('linnovateur-language'); if (['es','en'].includes(saved)) lang = saved; } catch {}
  const translate = text => {
    const clean = text.trim();
    let result = (lang === 'en' ? pairs : reverse)[clean];
    if (!result && /^\d+ referencias seleccionadas$/.test(clean) && lang === 'en') result = clean.replace('referencias seleccionadas','fragrances selected');
    if (!result && /^\d+ fragrances selected$/.test(clean) && lang === 'es') result = clean.replace('fragrances selected','referencias seleccionadas');
    return result ? text.replace(clean,result) : text;
  };
  let scheduled = false;
  const observer = new MutationObserver(() => { if (!scheduled) { scheduled = true; requestAnimationFrame(() => { scheduled = false; apply(); }); } });
  function apply() {
    observer.disconnect();
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: node => node.parentElement?.closest('script,style,svg,textarea,option,[translate="no"],#admin-bar-iframe') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    let node;
    while ((node = walker.nextNode())) { const next = translate(node.nodeValue); if (next !== node.nodeValue) node.nodeValue = next; }
    document.querySelectorAll('[placeholder],[aria-label]').forEach(el => {
      if (el.closest('[translate="no"]') || el.hasAttribute('data-language')) return;
      for (const attr of ['placeholder','aria-label']) if (el.hasAttribute(attr)) el.setAttribute(attr,translate(el.getAttribute(attr)));
    });
    document.documentElement.lang = lang;
    form.querySelectorAll('[data-language]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.language === lang)));
    observer.observe(document.body,{childList:true,subtree:true,characterData:true});
  }
  form.querySelectorAll('[data-language]').forEach(button => button.addEventListener('click', () => {
    lang = button.dataset.language;
    try { localStorage.setItem('linnovateur-language',lang); } catch {}
    const available = form.querySelector('[data-native-languages]').dataset.nativeLanguages.split(/\s+/);
    if (available.includes(lang) && available.includes('es') && available.includes('en')) {
      form.querySelector('[name=locale_code]').value=lang; form.submit(); return;
    }
    apply();
  }));
  apply();
})();
